<template>
    <div>

        <div class="panel panel-info" v-if="smtp">
            <div class="panel-heading">
                <i class="fa fa-info-circle" aria-hidden="true"></i> Cadastro de SMTP
            </div>
            <div class="panel-body" >

                <div class="form-group">
                    <div class="col-sm-6">
                        <br/>
                        <label for="host" class="control-label">HOST:</label>
                        <input id="host" type="text" v-model="smtp.host" class="form-control" >
                    </div>
                    <div class="col-sm-6">
                        <br/>
                        <label for="email" class="control-label">EMAIL:</label>
                        <input id="email" type="text" v-model="smtp.username" class="form-control" >
                    </div>
                </div>

                <div class="form-group">
                    <div class="col-sm-5">
                        <br/>
                        <label for="password" class="control-label">SENHA:</label>
                        <input id="password" type="password" v-model="smtp.password" class="form-control" >
                    </div>
                    <div class="col-sm-1">
                        <br>
                        <label class="control-label">&nbsp;</label>
                        <button type="button" class="btn btn-default" @click="change()">
                            <i class="fa fa-eye" aria-hidden="true"></i>
                        </button>
                    </div>
                    <div class="col-sm-3">
                        <br/>
                        <label for="email" class="control-label">SSL:</label>
                        <select v-model="smtp.ssl" class="form-control" >
                            <option :value="false">NÃO</option>
                            <option :value="true">SIM</option>
                        </select>
                    </div>
                    <div class="col-sm-3">
                        <br/>
                        <label for="port" class="control-label">PORTA:</label>
                        <input id="port" v-model="smtp.port" class="form-control" >
                    </div>
                </div>

            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-10">
                <button type="button" @click="send()" class="btn btn-success">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i> SALVAR SMTP
                </button>
            </div>
        </div>

    </div>
</template>
<script>
import { SMTP } from "../../../class/index";
import pontoComputedMixin from "../../mixins/smtp_computed";
/* global $*/
export default {
    mixins: [pontoComputedMixin],
    data() {
        return {
            type: "text"
        };
    },
    methods: {
        change() {
            let passwordField = $("#password");
            // Get the current type of the password field will be password or text
            let passwordFieldType = passwordField.attr("type");
            // Check to see if the type is a password field
            if (passwordFieldType === "password") {
                // Change the password field to text
                passwordField.attr("type", "text");
            } else {
                // If the password field type is not a password field then set it to password
                passwordField.attr("type", "password");
            }
        },

        send() {
            swal.queue([
                {
                    title: "Comandos",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o SMTP?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            SMTP.save(this.smtp)
                                .then(() => {
                                    this.$router.push("/smtps");
                                    resolve();
                                })
                                .catch(err => {
                                    if (err.data && err.data.code === 403) {
                                        return swal(
                                            "Usuário",
                                            "Email já sendo usado",
                                            "error"
                                        );
                                    }
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
